import { Component, OnInit } from '@angular/core';
import {
  SelectedCustomerService,
  Customer,
  AuthService,
  GungBase,
  CustomerService,
  CustomerContactService,
  GungFlowService,
  CartService,
  AvailabilityService,
  GungFlow,
  CustomerContact,
  CartRow
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { AssignJeevesDefaultsComponent, JeevesDeliveryAddressesService } from 'gung-standard-jeeves';
import { first } from 'rxjs';
import { User } from 'gung-standard/lib/state/auth/types';

@Component({
  selector: 'cult-cult-checkout-defaults',
  templateUrl: './cult-checkout-defaults.component.html',
  styleUrls: ['./cult-checkout-defaults.component.scss']
})
export class CultCheckoutDefaultsComponent extends AssignJeevesDefaultsComponent implements OnInit {
  private user: User;

  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected customerContactService: CustomerContactService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService
  ) {
    super(
      selectedCustomerService,
      customerService,
      customerContactService,
      gungFlowService,
      authService,
      cartService,
      availabilityService,
      dateUtilService,
      jeevesDeliveryAddressesService
    );
  }

  ngOnInit() {
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.user = user;
        super.ngOnInit();
      });
  }

  protected setValues(
    customer: Customer,
    flow: GungFlow,
    user,
    customerContacts: CustomerContact[],
    billingCustomer?: Customer,
    cartRows?: CartRow[]
  ) {
    super.setValues(customer, flow, user, customerContacts, billingCustomer, cartRows);
    const baseUser = this.user as unknown as GungBase;
    if (baseUser.extra.orderParams) {
      // set orderparams
      this.checkout.extra.procargs.saljare = baseUser.extra.orderParams.oh.saljare;
    }
    if (this.user.email) {
      if (!this.checkout.extra.confirmationEmails) {
        this.checkout.extra.confirmationEmails = [];
      }
      if (!this.checkout.extra.confirmationEmails.includes(this.user.email)) {
        this.checkout.extra.confirmationEmails.push(this.user.email);
      }
    }

    if (!flow.isReturnOrder) {
      this.checkout.extra.procargs.ordlevadr3 = customer.extra.fr.ftgpostadr5;
      this.checkout.extra.procargs.ordlevadr4 = customer.extra.fr.ftglevpostnr + ' ' + customer.extra.fr.ftgpostlevadr3;
    }

    // this.checkout.extra.oh.salestype = '23';
  }
}
